import React from 'react';
import { message } from 'antd';
import { FormOutlined } from '@ant-design/icons';
import AppIconGroup from '../../components/app-icon-group';
import List from './list';
import getVersionMeta from '../../utils/get-version-meta';

const iconStyle = {
    fontSize: 28,
}

export default () => {
    const accId = window.__baseInfo.accId;
    const version = getVersionMeta();
    const versionCheck = async () => { 
        let response = await fetch(`/api/shop/my-list?accId=${accId}&status=1`);
        let result = await response.json();

        if(result?.data?.length >= version.shops) {
            message.error('当前版本已达到最大店铺数，请联系销售升级版本');
        }else {
            window.location.href = '/shop/create';
        }
    }
    
    return (
        <div>
            {/* 快捷操作 - iOS 风格图标组 */}
            {!window.__baseInfo.isSub && (
                <div className="mt-3 mb-4">
                    <AppIconGroup 
                        items={[
                            {
                                id: 1,
                                onClick: versionCheck,
                                title: '创建店铺',
                                icon: <FormOutlined />,
                                color: 'from-blue-500 to-blue-600'
                            }
                        ]}
                        cols="3-3-3-3-3"
                    />
                </div>
            )}
            
            <List accId={accId} />
        </div>
    )
}